export default "__VITE_ASSET__BgFdj0YS__"